// extracted by mini-css-extract-plugin
export default {"select":"CustomSelect_select__hEcuP","filledUp":"CustomSelect_filledUp__OmsUH"};